export const navId = 'flexera-main-nav';
export const navFooterId = 'flexera-nav-footer';
export const navSearchId = 'flexera-nav-search';
